import { Component } from 'react';
import { UniGrid } from '../UniGrid';
import { Button, DataGrid, Form, Popup, SelectBox, TextBox } from 'devextreme-react';
import { DropDownButton, Item as DdbItem } from 'devextreme-react/drop-down-button';
import { ButtonItem, ButtonOptions, Label, SimpleItem } from 'devextreme-react/form';
import Inline from '../Inline';
import PropTypes from 'prop-types';
import { apiGetP, apiPost, apiPostNoBody, apiPostNoBodyP, apiPostP } from '../../GanjiTools';
import TreeList, { Sorting, Column as TColumn, TreeListHeaderFilter } from 'devextreme-react/tree-list';
import { Grouping, GroupItem } from 'devextreme-react/data-grid';
import MinimalButton from '../MinimalButton';
import Spinner from '../utils/Spinner';
import './TableBuilder.css';
import TablesTree from './TablesTree';


// copied from unicontroller
const allTypes = 'int/smallint/tinyint/float/real/bit/text/date/datetime/time/timestamp/nvarchar/nchar/varchar/char/binary/varbinary/datetimeoffset/image/uniqueidentifier';
const varLengthTypes = 'nvarchar/nchar/varchar/char/binary/varbinary/datetimeoffset/time';

const sqlColumns = [
    { name: 'name', readonly: true, caption: 'نام' },
    { name: 'newname', caption: 'نام جدید', visible: 'form', rtl: false },
    { name: 'descr', caption: 'تعریف', colSpan: 2 },
    { name: 'dataType', caption: 'نوع', lookup: allTypes.split('/'), rtl: false, required: true }, //, lookup: [{ id: 1, summary: 'int' }, { id: 2, summary: 'nvarchar' }] },
    { name: 'dataLength', caption: 'اندازه', rtl: false },
    { name: 'nullable', caption: 'Nullable', format: 'bool' },
    { name: 'ltr', caption: 'چپ به راست', format: 'bool' },
    { name: 'caption_Fa', caption: 'عنوان فارسی' },
    { name: 'caption_En', caption: 'عنوان لاتین', rtl: false },
    { name: 'caption_Ar', caption: 'عنوان عربی' },
    { name: 'width', caption: 'عرض', format: 'float', rtl: false },
    { name: 'formSection', caption: 'سکشن فرم' },
    { name: 'order', caption: 'ترتیب', format: 'float', rtl: false },
    { name: 'isHidden', caption: 'مخفی', format: 'bool' },
    { name: 'isReadonly', caption: 'فقط خواندنی', format: 'bool' },
    { name: 'isImage', caption: 'تصویر', format: 'bool' },
    {
        name: 'component', ltr: true, caption: 'کمپوننت',
        lookup: [ ///////////////////////////////
            'NumberBox',
            'TextBox',
            'TextArea',
            'DateBox',
            'DatePicker',
            'TimePicker',
            'CheckBox',
            'Switch',
            'SelectBox',
            'Button'
        ]
    },
    { name: 'componentProps', colSpan: 2, caption: 'خصوصیات کمپوننت', component: 'TextArea', rtl: false },
    { name: 'foreignKey', caption: 'کلید خارجی', rtl: false },
    { name: 'jsExpression', colSpan: 2, caption: 'عبارت جاواسکریپت', rtl: false },
];

class TableBuilder extends Component {
    state = {
        columns: this.props.columns ?? [],
        dbAllTableNames: [],
        tables: [],
        tablesKey: 1,
        columnsKey: 1,
        focusedTable: this.props.table ?? {},
        schemas: [],
        parentColName: '',
        groupColName: '',
        viewMode: 'design',
    }

    loadData = (tableName, forceLoadTablesList, onSeccess) => {
        //this.setState({ loading: true });
        let fltl = `forceLoadTablesList=${forceLoadTablesList ? 'y' : 'n'}`;
        tableName = tableName?.toLowerCase?.() ?? '';
        let url = tableName?.length > 0 ? `/api/dyna/dbdata/${tableName}?includeColumns=s&${fltl}` : `/api/dyna/dbdata?includeColumns=n&${fltl}`;

        apiGetP(url)
            .catch(err => {
                window.notif(err);
                //this.setState({ loading: false });
            })
            .then(res => {
                //res ??= { list: [], parentColName: '', groupColName: '' };
                let { tableProps, parentColName, groupColName, summaryColName, schemas } = res ?? { tableProps: [], parentColName: '', groupColName: '', summaryColName: '', schemas: [] };
                let tablesNotUpdated = tableName?.length > 0 && !forceLoadTablesList;
                let tables = tablesNotUpdated ? this.state.tables : tableProps.filter(x => x.schema !== 'Uni');
                schemas = schemas.filter(x => x !== 'Uni');
                let tablesTree = this.state.tablesTree ?? [];

                if (!tablesNotUpdated) {
                    let idCounter = 1;
                    tablesTree = schemas.map(x => ({ id: ++idCounter, name: x, parent: null, icon: 'folder' }));
                    let tablesBranches = tables.map(x => ({ id: ++idCounter, name: x.tableName, parent: x.schema, icon: 'detailslayout' }));
                    tablesTree = [...tablesTree, ...tablesBranches].sort((a, b) => a.name < b.name ? -1 : a.name === b.name ? 0 : 1)
                }

                this.setState({
                    tables,
                    tablesTree,
                    parentColName,
                    groupColName,
                    summaryColName,
                    columns: tableName?.length > 0
                        ? tableProps.find(x => x.tableName?.toLowerCase?.() === tableName)
                            ?.columns?.filter(x => x.name?.toLowerCase() !== 'id')?.map(x => ({ ...x, foreignKey: x.foreignKey?.referencedTable })) ?? []
                        : [],
                    schemas,
                    tablesKey: this.state.tablesKey + 1,
                    columnsKey: tableName?.length > 0 ? this.state.columnsKey + 1 : this.state.columnsKey,
                    //loading: false,
                }, onSeccess);
            });
    }

    addNewTable = () => {
        if (this.state.newTableSchema?.length > 0 && this.state.newTableName?.length > 0)
            apiPostNoBodyP(`/api/dyna/addTable?table=${this.state.newTableName}&schema=${this.state.newTableSchema}`)
                .catch(window.notif)
                .then(res => {
                    res ??= { error: 'No response.' };
                    if (res.error?.length > 0) {
                        window.notif(res.error);
                        return;
                    }

                    this.loadData(this.state.newTableName, true,
                        () => this.setState({ focusedTable: this.state.tables.find(x => x.tableName?.toLowerCase() === this.state.newTableName.toLowerCase()) }));
                });
        else
            window.notif('نام جدول یا شما خالی است');
    }

    addNewSchema = () => {
        apiPostNoBodyP(`/api/dyna/addSchema?name=${this.state.newSchemaName}`).catch(window.notif)
            .then(() => this.loadData('', true));
    }

    onDeleteTable = () => {
        if (this.state.focusedTable?.tableName?.length > 0)
            apiPostNoBodyP(`/api/dyna/deleteTable?table=${this.state.focusedTable.tableName}&schema=${this.state.focusedTable.schema}`)
                .catch(window.notif)
                .then(res => {
                    res ??= { error: 'No response.' };
                    if (res.error?.length > 0) {
                        window.notif(res.error);
                        return;
                    }

                    this.loadData('', true, () => this.setState({ focusedTable: '' }));
                });
        else
            window.notif('نام جدول یا شما خالی است');
    }

    saveTableProps = () => {
        if (this.state.focusedTable?.tableName?.length > 0)
            apiPostNoBodyP(`/api/dyna/saveTableProps?tableName=${this.state.focusedTable.tableName}&parentColName=${this.state.parentColName ?? ''}&groupColName=${this.state.groupColName ?? ''}&summaryColName=${this.state.summaryColName ?? ''}`)
                .catch(window.notif)
                .then(res => {
                    res ??= { error: 'No response.' };
                    if (res.error?.length > 0) {
                        window.notif(res.error);
                        return;
                    }
                    console.log(res.uniGridOption);
                });
    }

    onFocusedTableChanged = res => {
        let { tableName, parentColName, groupColName, summaryColName, columns } = res ?? { tableName: '' };

        this.state.focusedTable = tableName?.length > 0 ? this.state.tables?.find(x => x.tableName.toLowerCase() === tableName.toLowerCase()) : '';

        if (tableName?.length > 0) {
            this.state.parentColName = parentColName;
            this.state.groupColName = groupColName;
            this.state.summaryColName = summaryColName;
            this.state.columns = columns;
        }
        this.forceUpdate();
    }

    setViewMode = viewMode => {
        this.setState({ viewMode });
    }

    componentDidMount() {
        this.loadData(this.state.focusedTable?.tableName, true);
    }

    renderTablesTreeCell = c => {
        let { name, icon } = c?.data ?? { name: '', icon: '' };
        return (
            <div style={{ fontWeight: name === this.state.focusedTable?.tableName ? 'bold' : 'normal' }}>
                <span className={'dx-icon-' + icon}></span>
                <span style={{ marginLeft: '5px' }}>{name}</span>
                {/* {name === this.state.focusedTable?.tableName && <span className='dx-icon-arrowright' style={{ marginLeft: '1rem' }}></span>} */}
            </div>
        )
    }

    render() {
        if (this.state.loading)
            return (<Spinner />);

        let cols = [
            ...sqlColumns.filter(x => x.name.toLowerCase() !== 'foreignkey'),
            {
                name: 'foreignKey',
                lookup: this.state.tables?.map(x => `${x.schema}.${x.tableName}`),
                rtl: false,
            }
        ];

        let colNames = this.state.columns?.map(x => x.name) ?? [];
        colNames.push('');

        return (
            <>
                <Inline spacing='1rem' style={{ alignItems: 'start' }}>
                    <div style={{ width: 'calc(100vw - 450px)', height: 'calc(100vh - 6rem)' }}>
                        {this.state.viewMode === 'design' ?
                            <UniGrid rows={this.state.columns} ignoreUserCheck width='100%' height='calc(100vh - 13rem)' //'calc(100vw - 450px)'
                                key={`cg${this.state.columnsKey}_${this.state.focusedTable?.tableName}`}
                                columns={cols}
                                title={`خصوصیات ستونها: ${this.state.focusedTable?.tableName ?? ''}`}
                                onManualUpdateRow={(id, newData, oldData, onError) => {
                                    let row = { ...oldData, ...newData, id };
                                    if (this.state.focusedTable?.tableName?.length > 0)
                                        apiPostP(`/api/dyna/saveColumn?cmd=update&schema=${this.state.focusedTable.schema}&table=${this.state.focusedTable.tableName}`,
                                            { ...row, foreignKey: { referencedTable: row.foreignKey } }
                                        ).catch(window.notif).then(() => this.loadData(this.state.focusedTable, true));
                                }}

                                onManualCreateRow={(row, onError) => {
                                    if (this.state.focusedTable?.tableName?.length > 0)
                                        apiPostP(`/api/dyna/saveColumn?cmd=add&schema=${this.state.focusedTable.schema}&table=${this.state.focusedTable.tableName}`,
                                            { ...row, foreignKey: { referencedTable: row.foreignKey }, id: 0 }
                                        ).catch(window.notif).then(() => this.loadData(this.state.focusedTable, true));
                                }}

                                onManualDeleteRow={id => {
                                    apiPostP(`/api/dyna/saveColumn?cmd=del&schema=${this.state.focusedTable.schema}&table=${this.state.focusedTable.tableName}`,
                                        { id, name: this.state.columns?.find(x => x.id === id)?.name }
                                    ).catch(window.notif).then(() => this.loadData(this.state.focusedTable, true));
                                }}
                            />
                            :
                            <UniGrid key={`prvg_${this.state.focusedTable?.tableName}`} table={this.state.focusedTable?.tableName}
                                title={`جدول: ${this.state.focusedTable?.tableName ?? ''}`}
                                ignoreUserCheck width='100%' height='calc(100vh - 13rem)'
                            />
                        }

                        <div style={{ height: '1rem' }}>&nbsp;</div>

                        {this.state.viewMode === 'design' &&
                            <Form colCount={60} width='100%' /*'calc(100vw - 450px)'*/ rtlEnabled key={'tblprop' + this.state.tablesKey}
                            >
                                <SimpleItem colSpan={12} >
                                    <Label text='نام جدول' />
                                    <TextBox value={this.state.focusedTable?.tableName} readOnly
                                        onValueChanged={e => this.setState({ focusedTable: { ...this.state.focusedTable, tableName: e.value } })}
                                    />
                                </SimpleItem>

                                <SimpleItem colSpan={12}>
                                    <Label text='شما' />
                                    <SelectBox dataSource={this.state.schemas} value={this.state.focusedTable?.schema} readOnly />
                                </SimpleItem>
                                <SimpleItem colSpan={12}>
                                    <Label text='فیلد مبنای وراثت' />
                                    <SelectBox dataSource={colNames} value={this.state.parentColName}
                                        onValueChanged={e => this.setState({ parentColName: e.value })}
                                    />
                                </SimpleItem>
                                <SimpleItem colSpan={12}>
                                    <Label text='فیلد مبنای گروه' />
                                    <SelectBox dataSource={colNames} value={this.state.groupColName}
                                        onValueChanged={e => this.setState({ groupColName: e.value })}
                                    />
                                </SimpleItem>
                                <SimpleItem colSpan={12}>
                                    <Label text='فیلد خلاصه' />
                                    <SelectBox dataSource={colNames} value={this.state.summaryColName}
                                        onValueChanged={e => this.setState({ summaryColName: e.value })}
                                    />
                                </SimpleItem>
                            </Form>
                        }
                        <Inline key={'bottoms_' + this.state.viewMode} spacing='1rem' style={{ alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}
                        >
                            <DropDownButton key={'btnViewMode_' + this.state.viewMode}
                                rtlEnabled showArrowIcon width='15rem'
                                text={this.state.viewMode === 'preview' ? 'پیش نمایش' : 'طراحی'}
                                icon={this.state.viewMode === 'preview' ? 'photo' : 'edit'}
                                selectedItemKey={this.state.viewMode}
                            >
                                <DdbItem text='طراحی' icon='edit' key='design' onClick={() => this.setViewMode('design')} />
                                <DdbItem text='پیش نمایش' icon='photo' key='preview' onClick={() => this.setViewMode('preview')} />
                            </DropDownButton>

                            {this.state.viewMode === 'design' &&
                                <Button text='شمای جدید ...' icon='plus' width='10rem' type='success' rtlEnabled
                                    onClick={() => this.setState({ newSchemaName: '', newSchemaPopVisible: true })}
                                />
                            }
                            {this.state.viewMode === 'design' && <Button text='جدول جدید ...' icon='plus' width='10rem' type='success' rtlEnabled
                                onClick={() => this.setState({ newTablePopVisible: true })}
                            />
                            }
                            {this.state.viewMode === 'design' && <Button text='ذخیره' icon='save' width='10rem' type='success' rtlEnabled
                                onClick={() => this.saveTableProps()}
                            />
                            }
                            {this.state.viewMode === 'design' && <Button text='حذف جدول' icon='trash' width='10rem' type='danger' rtlEnabled
                                onClick={() => this.onDeleteTable()} // !!!! add confirm
                            />
                            }
                        </Inline>
                    </div>

                    <TablesTree onFocusedTableChanged={this.onFocusedTableChanged}

                        //onTablesDataLoaded={({ tables, schemas }) => { }}
                        focusedTableName={this.state.focusedTable?.tableName}
                        formBased={false} rtlEnabled={false} width='200px' height='calc(100vh - 10rem)'
                    />

                    {/* {false &&
                        <TreeList  rtlEnabled={false} autoExpandAll keyExpr='name'
                            dataSource={this.state.tablesTree} parentIdExpr='parent' width='200px' height='calc(100vh - 10rem)'
                            focusedRowEnabled hoverStateEnabled showColumnHeaders={false}
                            focusedRowKey={this.state.focusedTable?.tableName}

                            onFocusedRowChanged={e => {
                                this.state.focusedTable = this.state.tables.find(x => x.tableName === e.row?.data?.name);
                                if (e.row?.data?.name?.length > 0)
                                    this.loadData(e.row?.data?.name, false);
                            }}
                        >
                            <TColumn dataField='name' cellRender={this.renderTablesTreeCell} />
                        </TreeList>
                    } */}
                </Inline>

                <Popup rtlEnabled title='شمای جدید' visible={this.state.newSchemaPopVisible} showCloseButton
                    onHiding={() => this.setState({ newSchemaPopVisible: false })} width='auto' height='auto'
                >
                    <Form colCount={60} width='30rem' height='auto' rtlEnabled
                    >
                        <SimpleItem colSpan={60}>
                            <Label text='نام' />
                            <TextBox value={this.state.newSchemaName}
                                onValueChanged={e => this.setState({ newSchemaName: e.value })}
                            />
                        </SimpleItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem' style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <Button text='ذخیره' icon='save' width='10rem' type='success' rtlEnabled
                            onClick={() => {
                                if (this.state.newSchemaName?.trim()?.length > 0)
                                    this.setState({ newSchemaPopVisible: false }, this.addNewSchema)
                            }}
                        />
                        <Button text='انصراف' icon='close' width='10rem' type='danger' rtlEnabled
                            onClick={() => this.setState({ newSchemaPopVisible: false })}
                        />
                    </Inline>
                </Popup>

                <Popup rtlEnabled title='جدول جدید' visible={this.state.newTablePopVisible} showCloseButton key={'newtable' + this.state.tablesKey}
                    onHiding={() => this.setState({ newTablePopVisible: false })} width='auto' height='auto'
                >
                    <Form colCount={60} width='30rem' height='auto' rtlEnabled key={'newtablefrm' + this.state.tablesKey}
                    >
                        <SimpleItem colSpan={60}>
                            <Label text='شما' />
                            <SelectBox dataSource={this.state.schemas} value={this.state.newTableSchema} key={'newtablefrmsc' + this.state.tablesKey}
                                onValueChanged={e => this.setState({ newTableSchema: e.value })}
                            />
                        </SimpleItem>
                        <SimpleItem colSpan={60}>
                            <Label text='نام جدول' />
                            <TextBox value={this.state.newTableName}
                                onValueChanged={e => this.setState({ newTableName: e.value })}
                            />
                        </SimpleItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem' style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <Button text='ذخیره' icon='save' width='10rem' type='success' rtlEnabled
                            onClick={() => {
                                if (this.state.newTableName?.trim()?.length > 0) {
                                    this.state.newTablePopVisible = false;
                                    this.addNewTable();
                                }
                                // this.setState({ newTablePopVisible: false }, // focusedTable: this.state.tables.find(x => x.tableName === this.state.newTableName.trim())
                                //     this.addNewTable
                                // );
                            }}
                        />
                        <Button text='انصراف' icon='close' width='10rem' type='danger' rtlEnabled
                            onClick={() => this.setState({ newTablePopVisible: false })}
                        />
                    </Inline>
                </Popup>

                {/* <Popup rtlEnabled title='جداول' visible={this.state.tablesPopVisible} showCloseButton key={'tablesPopVisible' + this.state.tablesKey}
                    onHiding={() => this.setState({ tablesPopVisible: false })} width='40rem' height='auto'
                >
                    <UniGrid dataSource={this.state.tables} readOnly //key={'tablesTl' + this.state.tablesKey}
                        keyExpr='id' groupBy='schema' ignoreUserCheck height='50vh'
                        columns={[{ name: 'tablename', caption: 'جدول' }, { name: 'schema', caption: 'Schema' }]}
                        onFocusedRowChanged={r => this.focusedTable = { ...r, tableName: r.tablename }}
                    />
                    <br />
                    <Inline spacing='1rem' style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <Button text='انتخاب' icon='check' width='10rem' type='success' rtlEnabled
                            onClick={() => this.setState({ tablesPopVisible: false, focusedTable: this.focusedTable },
                                () => this.loadData(this.focusedTable?.tableName, true))}
                        />
                        <Button text='انصراف' icon='close' width='10rem' type='danger' rtlEnabled
                            onClick={() => this.setState({ tablesPopVisible: false })}
                        />
                    </Inline>
                </Popup> */}
            </>
        );
    }
}

TableBuilder.propTypes = {
    columns: PropTypes.number
};

export default TableBuilder;